import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { animated, useSpring } from 'react-spring';
import { hide as hideRade } from 'emergency_data/src/components/JurisdictionView/RADECard/radeSlice';
import PropTypes from 'prop-types';
import { gspx } from '@rsos/capstone';
import {
  removeAllCalls,
  viewAllCalls,
} from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import {
  AVIVE_APP_LAUNCHER_MAP_CARD,
  closeCard,
} from '@rsos/reduxDataStore/src/features/mapCard/mapCardSlice';
import { EMERGENCY_CALLS } from '../../../../constants/incidentTypes';
import {
  Container,
  RemoveAll,
  Subtitle,
  Title,
  Wrapper,
} from './AllEvents.styles';
import RemoveAllEventsModal from './RemoveAllEventsModal';

/**
 *
 * @param {string} selectedCallerID - the selected caller id
 * @param {string} activeQueueTab - the selected tab (calls/alerts)
 * @param {boolean} hasCalls - if length of calls > 0
 *
 */
const AllEvents = ({
  hasCalls,
  activeQueueTab,
  selectedCallerID,
  onViewJurisdiction,
}) => {
  const dispatch = useDispatch();
  const { display_name: psapDisplayName } = useSelector(
    state => state.psaps.currentPSAP,
  );
  const { irpVersion } = useSelector(state => state.sinatra.irp);
  const [removeAllVisible, setRemoveAllVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const animateProps = useSpring({
    config: { duration: 200 },
    display: removeAllVisible ? 'flex' : 'none',
    opacity: removeAllVisible ? 1 : 0,
  });

  const handleViewAll = () => {
    dispatch(viewAllCalls());
    dispatch(hideRade());
    onViewJurisdiction();
    gspx.trackCustomEvent('Data Jurisdiction', {
      irpVersion,
      name: 'Click on All Calls',
      Category: 'Jurisdiction View',
      'Launched date': new Date(),
      serviceType: '',
      classOfServices: null,
    });
    dispatch(closeCard(AVIVE_APP_LAUNCHER_MAP_CARD));
  };

  const handleRightClick = e => {
    e.preventDefault();
    e.stopPropagation();

    gspx.trackCustomEvent('Data Jurisdiction', {
      irpVersion,
      name: 'Right-click on All Calls',
      Category: 'Jurisdiction View',
      'Launched date': new Date(),
    });

    if (activeQueueTab === EMERGENCY_CALLS && !selectedCallerID && hasCalls) {
      // remove all is not enabled for Alerts
      setRemoveAllVisible(true);
    }
  };

  const handleRemoveAllEvents = () => {
    gspx.trackCustomEvent('Data Jurisdiction', {
      irpVersion,
      name: 'Clicks on remove from remove all calls modal',
      Category: 'Jurisdiction View',
      'Launched date': new Date(),
    });
    if (activeQueueTab === EMERGENCY_CALLS) {
      dispatch(removeAllCalls());
    } else {
      // next phase remove all alerts
      // dispatch(removeAllAlerts());
    }
    setRemoveAllVisible(false);
    setIsModalVisible(false);
  };

  const titleText = 'View Jurisdiction';

  const onClickHandler = () => setRemoveAllVisible(false);

  window.oncontextmenu = () => {
    setIsModalVisible(false);
    window.removeEventListener('click', onClickHandler, false);
  };

  useEffect(() => {
    window.addEventListener('click', onClickHandler, false);

    return () => {
      window.removeEventListener('click', onClickHandler, false);
    };
  }, []);

  return (
    <>
      <Container onContextMenu={handleRightClick}>
        <Wrapper onClick={() => handleViewAll()} data-name="all-911-events">
          <Title>{titleText}</Title>
          {psapDisplayName && <Subtitle>{psapDisplayName}</Subtitle>}
        </Wrapper>
        <animated.div style={animateProps}>
          <RemoveAll
            data-name="remove-all"
            onClick={() => setIsModalVisible(true)}
          >
            Remove All
          </RemoveAll>
        </animated.div>
      </Container>
      <RemoveAllEventsModal
        activeQueueTab={activeQueueTab}
        isOpened={isModalVisible}
        onConfirm={handleRemoveAllEvents}
        onClose={() => setIsModalVisible(false)}
      />
    </>
  );
};

AllEvents.propTypes = {
  selectedCallerID: PropTypes.string,
};

export default AllEvents;
